var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca638fc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlankDiv.vue
// module id = 1351
// module chunks = 1